export interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
}

export interface AlgoliaConfig {
  applicationId: string;
  searchAPIKey: string;
  index: string;
}

export interface AppConfig {
  auth0: Auth0Config;
  algolia: AlgoliaConfig;
}

const appConfig: { settings: AppConfig } = {
  get settings() {
    return this._settings;
  },
  set settings(value: AppConfig) {
    this._settings = value;
  },
};

if (window.location.hostname === 'toolkit.phdata.io') {
  appConfig.settings = require('src/config-prod.json');
} else if (window.location.hostname === 'toolkit-dev.phdata.io') {
  appConfig.settings = require('src/config-dev.json');
} else {
  appConfig.settings = require('src/config.json');
}

export const isDevEnv: boolean =
  window.location.hostname === 'toolkit-dev.phdata.io';

export function getAppConfig<T extends AppConfig>(): T {
  return appConfig.settings as T;
}
